<template>
    <Widget title="Flairs" :area="this.$props.area" :scrollable="true">
        <template v-if="hasData">
            <NameValue
                    v-for="{name,value} in flairs"
                    :key="name"
                    :name="name"
                    :value="value"
            />
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";

    export default {
        components: {NameValue, Widget},
        props: {area: String},
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            flairs() {
                let mapped = this.allPosts.map(d => d.data)
                    .filter(d => d.author_flair_text !== null && d.author_flair_text.length > 0)
                    .reduce((a, c) => {
                        a[c.subreddit] = c.author_flair_text;//a[c.domain] + 1 || 1;
                        return a;
                    }, {});

                return Object.entries(mapped).map(([name, value]) => {
                    return {name, value}
                }).sort((a,b)=>('' + a.name).localeCompare(b.name))
            },
            hasData() {
                return this.flairs.length > 0
            }

        },
        methods: {
            open() {
            }
        }
    }
</script>

<style scoped>

</style>
